<template>
	<div class="registerAgree">
   <div class="cont" v-html="contText"></div>
  </div>
</template>
<script setup>
import { getCurrentInstance, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
const { proxy } = getCurrentInstance();
const router = useRouter();
const route=useRoute();
const contText=ref("")
watch(()=>route.name.moduleName,()=>{
  getInfo()
})
function getInfo() {
  console.log(route.name.moduleName,'route.name.moduleName')
  proxy.$request({
    url: "PROTAL_N_PROTOCOL_GETPROTOCOLINFO",
    method: "post",
    data: {
      "portalType":proxy.getConfig().portalType,
      "moduleName":route.name.moduleName
    },
  }).then((res) => {
    if (res.data.code == "000") {
      contText.value=res.data.result.moduleCont;
    }
  }).catch((err) => {
    console.log(err);
  });
}
getInfo()

</script>

<style lang="less">
.registerAgree{
  background: #fff;
  padding: 24px;
  min-height: 100vh;
 .tit{
  font-family: PingFangSC-Semibold;
  color: #333;
  font-size: 16px;
  text-align: center;
  margin-bottom:20px;
 }
 .cont{
   font-family: PingFangSC;
  color: #333;
  font-size: 14px;
  line-height: 20px;
 }

}
</style>